var app = angular.module('leonardo');

var ColumnsSelector = function(ngDialog, FilterService) {
  return {
    restrict: 'A',
    require: ['ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@',
      placeholder: '@',
      filter: '@',
      name: '@',
      options: '=',
      allClean: '=',
      mode: '@',
      defaultValues: '=?',
      requiredFields: '=?',
      selectAll: '@',
      inline: '=',
      order: '=?',
      orderDisable: '=?'
    },
    templateUrl: 'views/templates/widget/columns-selector.html',
    link: function (scope, elem, attrs, ctrls) {
      scope.ngModelCtrl = ctrls[0];
      scope.formCtrl = scope.$parent.Form ? scope.$parent.Form : {'$submitted': true};
      scope.order = (scope.order !== undefined) ? scope.order : true;
      scope.value = null;
      scope.updating = false;
      scope.init = false;

      scope.ngModelCtrl.$render = function () {
        scope.defaultValues = angular.copy(scope.ngModelCtrl.$viewValue);
        if (!scope.defaultValues && scope.filter) {
          scope.defaultValues = FilterService.getFilter(scope.filter);
        }
        scope.init = true;
      };

      scope.showDialog = function () {
        let defaultArr = null;
        if (!isEmpty(scope.value)) {
          defaultArr = scope.value;
        }
        else {
          defaultArr = FilterService.hasFilter(scope.filter) ? FilterService.getFilter(scope.filter) : scope.defaultValues;
        }
        ngDialog.openConfirm(
          {
            template: 'views/templates/widget/columns-selector-dialog.html',
            controller: 'ColumnsSelectorController',
            data: {
              scopeData: scope,
              defaultValues: defaultArr,
            },
            showClose: false
          }
        ).then(function (data) {
          if(data.filterValues){
            scope.value = angular.copy(data.filterValues);
            scope.options = angular.copy(data.options);
          }else{
            scope.value = angular.copy(data);
          }
        }, function (error) {
          scope.value = '';
          scope.options = '';
        });
      };

      scope.$watch('options', function (newValue, oldValue) {
        if (!angular.equals(newValue,oldValue) || !scope.init) {
          if (angular.isArray(newValue)) {
            scope.options = newValue;
          }
        }
      });

      scope.$watch('value', function (newValue, oldValue) {
          if (!angular.equals(newValue, oldValue)) {
            scope.ngModelCtrl.$setViewValue(newValue);
            if (scope.filter) {
              scope.updating = true;
              if (isEmpty(scope.value)) {
                FilterService.removeFilter(scope.filter);
              } else {
                if (scope.allClean && (scope.value.length === scope.options.length)) {
                  FilterService.removeFilter(scope.filter);
                }
                else {
                  if (scope.mode === 'array') {
                    FilterService.setFilter(scope.filter, scope.value);
                  }
                  else {
                    FilterService.setFilter(scope.filter, scope.value.join(','));
                  }
                }
              }
            }
          }
      });

      scope.$on('filter-service:filter-changed', function ($event, key, value) {
        if (key === scope.filter) {
          if (!scope.updating) {
            scope.value = angular.isArray(value) ? value : value.split(',');
          }
          else {
            scope.updating = false;
          }
        }
      });

      scope.$on('filter-service:filter-removed', function ($event, key) {
        if (key === scope.filter) {
          if (!scope.updating) {
            scope.value = null;
          }
          else {
            scope.updating = false;
          }
        }
      });
    }
  };
};

var ColumnsSelectorController = function($scope, $q, $filter, $timeout, ngDialog, FilterService,ReportService, ConfigThemeService,FieldSubgroupServiceDetailsView,AuthDataService) {

  $scope.labelName = $scope.ngDialogData.scopeData.label;
  $scope.options = angular.copy($scope.ngDialogData.scopeData.options);
  $scope.mode = $scope.ngDialogData.scopeData.mode;
  $scope.selectAll = $scope.ngDialogData.scopeData.selectAll;
  $scope.allClean = $scope.ngDialogData.scopeData.allClean;
  $scope.order = $scope.ngDialogData.scopeData.order;
  $scope.orderDisable = $scope.ngDialogData.scopeData.orderDisable;
  $scope.defaultValues = $scope.ngDialogData.defaultValues;
  $scope.is_Details_view = ReportService.getDetailsView() ? ReportService.getDetailsView() : FilterService.filters && FilterService.filters.detailed ? FilterService.filters.detailed : false;
  $scope.sector = AuthDataService.authData.account ? AuthDataService.authData.account.sector : null;

  var url = window.location.href;
  var searchString = "property-amenities";

  if (url.includes(searchString)) {
    $scope.showPropertyAminitesFieldToShow = true
  } else if (FilterService.filters && FilterService.filters.detailed){
    $scope.showPropertyAminitesFieldToShow = true
  }else {
    $scope.showPropertyAminitesFieldToShow  = false
  }

  if(($scope.showPropertyAminitesFieldToShow && !$scope.is_Details_view) || (!$scope.showPropertyAminitesFieldToShow)){
    $scope.options = $scope.options.filter(item => !item.hasOwnProperty('groupId'));
  }


  $scope.elementsSelected = [];
  $scope.filterValues = [];
  $scope.columnsAvailable = [];
  $scope.columnSelected = {};
  $scope.resultArray = {};
  $scope.subGroupsNotAvailable = "";
  $scope.selectedSubGroups = "";
  $scope.validSubGroups = [];
  $scope.selectedOptionsDefault =[];
  $scope.dropDownSelectedValue =[];
  $scope.selectedOptions="";


  if (!isNull($scope.ngDialogData.scopeData.requiredFields)){
    $scope.requiredFields = angular.isArray($scope.ngDialogData.scopeData.requiredFields) ?
      $scope.ngDialogData.scopeData.requiredFields : $scope.ngDialogData.scopeData.requiredFields.split(',');
  }

  $scope.isNull = isNull;
  $scope.validSubFields = [];
  if ($scope.is_Details_view && $scope.labelName === 'Fields To Show') {
    FieldSubgroupServiceDetailsView.getAll({ summary: true, sector: $scope.sector })
      .then(function (results) {
        var fields =[];
        angular.forEach(results, function (subgroup) {
          fields.push({ id: subgroup.key, name: subgroup.name, fields: subgroup.fields });
        });
        $scope.options =  fields;
        angular.forEach($scope.options, function (subgroup) {
          if (subgroup.group) {
            if ((subgroup.group.id != 1) || !_.contains(['property_address', 'working_days'], subgroup.key)) {
              $scope.validSubGroups.push(subgroup);
            }
          } else {
            $scope.validSubGroups.push(subgroup);
          }
        });
  
        $scope.validSubGroups = $scope.validSubGroups.filter(item => item.id !== 'groups' && item.id !== 'pms_external_id' && !item.hasOwnProperty('groupId'));
        //Save FieldSaveGroup Data in ReportFilterService
        ReportFilterService.selectedOptionFieldToShow = $scope.validSubGroups;

      })
      .catch(function (error) {
        console.error('Error fetching data:', error);
      });
  }

  // Function to handle dropdown changes
  $scope.onDropdownChange = function(selectedOptions) {
      $scope.selectedSubGroups = selectedOptions;
      if (selectedOptions) {
          $scope.selectDropDownAvailableColumn(selectedOptions);
      } else {
          $scope.selectedOptionsDefault = [];
          $scope.columnsAvailable = [];
      }
  };

  
  $scope.selectDropDownAvailableColumn = function(selectedOptions) {
    // Convert Array  
    var selectedOptionArray = selectedOptions.split(',');
    // Filter validSubGroups based on the selected options
    var selectedSubGroups = $scope.validSubGroups.filter(item => selectedOptionArray.includes(item.id));
    $scope.dropDownSelectedValue = selectedSubGroups;
    var allFields =[]
    selectedSubGroups.forEach(function(subGroup) {
      
      if (subGroup.fields) {
        subGroup.fields.forEach(function(field) {
          // Push data into allFields
          allFields.push({
            name: field.name,
            id: field.key,
            groupId: subGroup.id
          });

          // Push data into $scope.options
          $scope.options.push({
            name: field.name,
            id: field.key,
            groupId: subGroup.id
          });
        });
      }
    });
    $scope.columnsAvailable = allFields;
    $scope.selectColumnsAvailable = allFields;
    if($scope.elementsSelected && $scope.elementsSelected.length > 0){
      $scope.columnsAvailable = $scope.columnsAvailable.filter(function(column) {
        return !$scope.elementsSelected.some(function(element) {
            return element.id === column.id;
        });
      });
    }
    
  };

  $scope.isRequired = function (element) {
    var selected = element || $scope.columnSelected;
    if ($scope.requiredFields && selected) {
      var id = !isNull(selected.id) ? selected.id.toString() : '';
      return $scope.requiredFields.includes(id);
    }
    else {
      return false;
    }
  };

  $scope.getName = function(element){
    var name = '';
    if (element.name) {
      name = element.name;
    }
    else if (element.label) {
      name = element.label;
    }
    return name;
  };

  $scope.existKey = function(obj) {
    var exist = false;
    angular.forEach($scope.options, function (option) {
      if (option.id === obj) {
        exist = true;
      }
    });
    return exist;
  };

  $scope.initOptions = function() {
    if ($scope.mode === 'array') {
      var options = [];
      angular.forEach($scope.options, function(value, key){
        if(!angular.isObject(value)) {
          options.push({id:key, name:value});
        }
        else {
          options.push(value);
        }
      });
      $scope.options = options;
    }
    if (!$scope.order) {
      $scope.columnsAvailableDefault = angular.copy($scope.options);
    }
    if(($scope.showPropertyAminitesFieldToShow && !$scope.is_Details_view) || ($scope.showPropertyAminitesFieldToShow && $scope.is_Details_view && $scope.labelName !== 'Fields To Show') || (!$scope.showPropertyAminitesFieldToShow)){
      $scope.columnsAvailable = angular.copy($scope.options);
    }
  };

  $scope.setDefaultValues = function() {
    $q.when($scope.options).then(function(data){
      $scope.options = data && data.results ? data.results : data;
      $scope.initOptions();
      $scope.elementsSelected = [];
      $scope.filterValues = [];
      $scope.defaultfilteredArr = [];

      if (!isNull($scope.defaultValues)) {
        if($scope.is_Details_view){
          $scope.defaultfilteredArr = $scope.options.filter(function(item) {
            return $scope.defaultValues.includes(item.id);
          });
          $scope.selectedOptionsDefault = [...new Set(
            $scope.defaultfilteredArr
              .filter(item => item.groupId)
              .map(item => item.groupId) 
          )];
        }

        if (angular.isArray($scope.defaultValues)) {
          $scope.filterValues = $scope.defaultValues;
        }
        else {
          if (angular.isString($scope.defaultValues)) {
            $scope.filterValues = $scope.defaultValues.split(',');
          }
          else {
            $scope.filterValues.push($scope.defaultValues);
          }
        }
      }
      if (!isNull($scope.requiredFields)) {
        angular.forEach($scope.requiredFields, function (required) {
          if (!$scope.filterValues.includes(required)) {
            $scope.filterValues.push(required);
          }
        });
      }
      var values_valid = [];
      angular.forEach($scope.filterValues, function(value) {
        if (value && $scope.existKey(value)) {
          if (!isNaN(value)) {
            values_valid.push(parseInt(value));
          }
          else {
            values_valid.push(value);
          }
        }
      });
      $scope.filterValues = values_valid;
      $timeout(function(){
        $scope.initElementsSelected($scope.options && $scope.options.filter(isUnique));
        $scope.initFilterValues = angular.copy($scope.filterValues);
      }, 20);
    });
  };

  // Define a function to check for object uniqueness based on the 'id' property
  function isUnique(item, index, array) {
    // Find the index of the current item in the array
    const currentIndex = array.findIndex(obj => obj.id === item.id);
    // Return true if the current item is the first occurrence of this 'id'
    return currentIndex === index;
  }

  $scope.initElementsSelected = function(options){
    angular.forEach($scope.filterValues, function(value){
      if($scope.mode === 'user'){
        angular.forEach(options, function(element) {
          if (element.user) {
            if (!element.name) {
              element.name = $filter('username')(element.user);
            }
            if (element.id === value){
              $scope.addElement(element);
            }
          }
          else {
            if (!element.name) {
              element.name = $filter('username')(element);
            }
            if (element.id === value) {
              $scope.addElement(element);
            }
          }
        });
      }
      else{
        angular.forEach(options, function(element) {
          if ($scope.mode === 'object'){
            if (value.id == element.id) {
              $scope.addElement(element);
            }
          }
          else {
            if (value == element.id) {
              $scope.addElement(element);
            }
          }
        });
      }
    });
    if (($scope.filterValues.length === 0) && ($scope.mode === 'user')) {
      angular.forEach(options, function(element) {
        if (element.user) {
          element.name = $filter('username')(element.user);
        }
        else {
          element.name = $filter('username')(element);
        }
      });
    }
    if ($scope.order && $scope.columnsAvailable.length > 0) {
      if ($scope.columnsAvailable[0].name) {
        $scope.columnsAvailable = $filter('orderBy')($scope.columnsAvailable, 'name');
      }
      else if ($scope.columnsAvailable[0].label) {
        $scope.columnsAvailable = $filter('orderBy')($scope.columnsAvailable, 'label');
      }
    }
    $scope.all = $scope.is_Details_view && $scope.labelName === 'Fields To Show' ? $scope.isDetailsViewAllSelected() : $scope.isAllSelected();
  };

  $scope.selectElement = function(element) {
    if ($scope.requiredFields && element) {
      var id = !isNull(element.id) ? element.id.toString() : '';
      if ($scope.requiredFields.includes(id)){
        $scope.columnSelected = {};
        return;
      }
    }
    $scope.columnSelected = element;
  };

  $scope.getElementClasses = function(element) {
    var classes = [];
    if ($scope.isRequired(element)){
      classes.push('required');
    }
    else {
      var id = !isNull(element.id) ? element.id.toString() : '';
      if ($scope.columnSelected.id == id) {
        classes.push('active');
      }
    }
    return classes;
  };

  $scope.getBackground = function(element) {
    var id = !isNull(element.id) ? element.id.toString() : '';
    var color = 'white';
    if ($scope.columnSelected.id == id) {
      color = ConfigThemeService.getColor('primaryColor', 0.9);
    }
    return color;
  };

  $scope.indexAvailable = function(element) {
    var index = -1;
    var id = element ? element.id : $scope.columnSelected.id;
      angular.forEach($scope.columnsAvailable, function (value, key) {
        if (value.id === id) {
          index = key;
        }
      });
    return index;
  };

  $scope.indexVisible = function(element) {
    var index = -1;
    var id = null;
    if (element) {
      if (($scope.mode === 'user') && element.user){
        id = element.user.id;
      }
      else {
        id = element.id;
      }
    }
    else {
      if (($scope.mode === 'user') && $scope.columnSelected.user){
        id = $scope.columnSelected.user.id;
      }
      else {
        id = $scope.columnSelected.id;
      }
    }
    angular.forEach($scope.elementsSelected, function (value, key) {
      if (value.id === id) {
        index = key;
      }
    });
    return index;
  };

  $scope.addElement = function(element, all) {
    var id = null;
    if (element) {
      if (($scope.mode === 'user') && element.user){
        id = element.user.id;
      }
      else {
        id = element.id;
      }
    }
    else
      if (($scope.mode === 'user') && $scope.columnSelected.user){
        id = $scope.columnSelected.user.id;
      }
      else {
        id = $scope.columnSelected.id;
      }

    if (!element){
      if ($scope.mode === 'object') {
        angular.forEach($scope.filterValues, function(value) {
          if (value.id == id) {
            return;
          }
        });
      }
      else {
        if (_.contains($scope.filterValues, id)) return;
      }
    }

    var index = -1;
    if (element){
      $scope.elementsSelected.push(element);
      index = $scope.indexAvailable(element);
    }
    else{
      $scope.elementsSelected.push($scope.columnSelected);
      index = $scope.indexAvailable();
    }
    if (index >= 0) {
      $scope.columnsAvailable.splice(index, 1);
    }

    if (!element || all){
      if ($scope.mode === 'object') {
        if (element) {
          $scope.filterValues.push(element);
        }
        else {
          $scope.filterValues.push($scope.columnSelected);
        }
      }
      else {
        $scope.filterValues.push(id);
      }
    }

    $scope.all = $scope.is_Details_view && $scope.labelName === 'Fields To Show' ? $scope.isDetailsViewAllSelected() : $scope.isAllSelected();
  };

  $scope.removeElement = function() {
    var index = $scope.indexVisible();
    if (index >= 0){
      if (!isNull($scope.requiredFields) && $scope.requiredFields.includes($scope.filterValues[index])) {
        return;
      }
      $scope.elementsSelected.splice(index, 1);
      $scope.filterValues.splice(index, 1);
      if ($scope.order) {
        $scope.columnsAvailable.push($scope.columnSelected);
        if ($scope.columnsAvailable[0].name) {
          $scope.columnsAvailable = $filter('orderBy')($scope.columnsAvailable, 'name');
        }
        else if ($scope.columnsAvailable[0].label) {
          $scope.columnsAvailable = $filter('orderBy')($scope.columnsAvailable, 'label');
        }
      }
      else {
        var auxColumnsAvailable = [];
        angular.forEach($scope.columnsAvailableDefault, function(value_default){
          if (value_default.id == $scope.columnSelected.id) {
            auxColumnsAvailable.push($scope.columnSelected);
          }
          else{
            angular.forEach($scope.columnsAvailable, function(value){
              if (value_default.id == value.id) {
                auxColumnsAvailable.push(value_default);
              }
            });
          }
        });
        $scope.columnsAvailable = auxColumnsAvailable;
      }
    }

    $scope.all = $scope.is_Details_view && $scope.labelName === 'Fields To Show' ? $scope.isDetailsViewAllSelected() : $scope.isAllSelected();
  };

  $scope.isAllSelected = function () {
    return !isEmpty($scope.options) && ($scope.elementsSelected.length === $scope.options.length);
  };

  $scope.isDetailsViewAllSelected = function () {
    return (!isNull($scope.options) && ($scope.columnsAvailable.length === 0) && ($scope.elementsSelected.length !==0) &&  ($scope.elementsSelected.length < $scope.options.length) && ($scope.options.length > 1));
  };

  $scope.isAllSelected = function () {
    return (!isNull($scope.options) && ($scope.elementsSelected.length === $scope.options.length) && ($scope.options.length > 1));
  };

  $scope.move = function(array, old_index, new_index) {
    while (old_index < 0) {
        old_index += array.length;
    }
    while (new_index < 0) {
        new_index += array.length;
    }
    if (new_index >= array.length) {
        var k = new_index - array.length;
        while ((k--) + 1) {
            array.push(undefined);
        }
    }
    array.splice(new_index, 0, array.splice(old_index, 1)[0]);
    return array;
  };

  $scope.upElement = function(){
    var index = $scope.indexVisible();
    if (index > 0) {
      $scope.elementsSelected = $scope.move($scope.elementsSelected, index, index-1);
      $scope.filterValues = $scope.move($scope.filterValues, index, index-1);
    }
  };

  $scope.downElement = function(){
    var index = $scope.indexVisible();
    if (index < $scope.elementsSelected.length-1) {
      $scope.elementsSelected = $scope.move($scope.elementsSelected, index, index+1);
      $scope.filterValues = $scope.move($scope.filterValues, index, index+1);
    }
  };

  $scope.selectAll = function() {
    var allSelection = $scope.is_Details_view && $scope.labelName === 'Fields To Show' ? $scope.isDetailsViewAllSelected() : $scope.isAllSelected();
    if (!allSelection){
      var options = angular.copy($scope.columnsAvailable);
      angular.forEach(options, function(value){
        $scope.addElement(value, true);
      });
    }
    else {
      if($scope.is_Details_view && $scope.selectedSubGroups){
        $scope.selectDropDownAvailableColumn($scope.selectedSubGroups);
        let resultArray = $scope.elementsSelected.filter(element =>
            !$scope.selectColumnsAvailable.find(item =>
                item.id === element.id && item.groupId === element.groupId
            )
        );
        $scope.elementsSelected = resultArray
        
        $scope.columnsAvailable = $scope.selectColumnsAvailable;
        $scope.filterValues = angular.copy($scope.elementsSelected.map(function(element) {
          return element.id;
        }));
      }
      else{
        $scope.elementsSelected = [];
        $scope.filterValues = [];
        
      }
      $scope.initOptions();
        
      if (!isNull($scope.requiredFields)) {
        $scope.filterValues = angular.copy($scope.requiredFields);
        $scope.initElementsSelected($scope.options);
      }
      
    }
  };

  $scope.cancel = function() {
    $scope.elementsSelected = [];
    $scope.filterValues = [];
    if($scope.is_Details_view){
      $scope.columnsAvailable = [];
      $scope.selectedOptionsDefault = [];
      $scope.selectedOptions=""
    }
    $scope.initOptions();
    if (!isNull($scope.requiredFields)) {
      $scope.filterValues = angular.copy($scope.requiredFields);
      $scope.initElementsSelected($scope.options);
    }
    $scope.resultArray = {
      filterValues: $scope.filterValues,
      options: angular.copy($scope.ngDialogData.scopeData.options)
    };
    // $scope.confirm($scope.is_Details_view ? $scope.resultArray : $scope.filterValues);

    
  };

  $scope.close = function() {
    $scope.resultArray = {
      filterValues: $scope.initFilterValues,
      options: angular.copy($scope.ngDialogData.scopeData.options)
    };
    $scope.confirm($scope.is_Details_view ? $scope.resultArray : $scope.filterValues);

  };

  $scope.submit = function() {
    $scope.resultArray = {
      filterValues: $scope.filterValues,
      options: $scope.options
    };

    $scope.confirm($scope.is_Details_view ? $scope.resultArray : $scope.filterValues);
  };

  $scope.setDefaultValues();
};


app.directive('columnsSelector', ['ngDialog', 'FilterService', ColumnsSelector]);

app.controller('ColumnsSelectorController', ['$scope', '$q', '$filter', '$timeout', 'ngDialog', 'FilterService','ReportService',
  'ConfigThemeService','FieldSubgroupServiceDetailsView','AuthDataService', ColumnsSelectorController]);